import * as angular from 'angular';
import { NotificationConstants } from 'angular/constants/NotificationConstants';
import { NetworkPointResource } from 'app/_resources/network-point.resource';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'QuickFilterPlatformSettingsCtrl',
            QuickFilterPlatformSettingsCtrl
        );

    function QuickFilterPlatformSettingsCtrl(
        $scope,
        $timeout,
        platformSettingsService,
        NetworkPoint: NetworkPointResource
    ) {
        var vm = this;

        vm.uiShowAddNewQuickFilter = false;
        vm.uiFailedToQueryQuickFilters = false;
        vm.uiQueriedQuickFilters = false;
        vm.uiNewQuickFilterSuccessRes = false;
        vm.uiNewQuickFilterErrorRes = false;
        vm.uiDeleteQuickFilterSuccessRes = false;
        vm.uiDeleteQuickFilterError = false;
        vm.uiEditQuickFilterSuccessRes = false;
        vm.uiEditQuickFilterErrorRes = false;
        vm.uiMaximumNumberOfFiltersReached = false;
        vm.quickFilters = [];
        vm.NEW_QUICK_FILTER_PAGE =
            platformSettingsService.NEW_QUICK_FILTER_PAGE;
        vm.remove = remove;
        vm.quickFilterToBeRemoved = null;

        NetworkPoint.queryQuickFilters(
            undefined,
            function (res) {
                vm.quickFilters = res;
                vm.uiQueriedQuickFilters = true;
                if (vm.quickFilters.length >= 5) {
                    vm.uiMaximumNumberOfFiltersReached = true;
                }
            },
            function () {
                vm.uiFailedToQueryQuickFilters = true;
                vm.uiQueriedQuickFilters = true;
            }
        );

        $scope.$on(
            platformSettingsService.BROADCAST.CANCEL_NEW_QUICK_FILTER,
            function () {
                vm.uiShowAddNewQuickFilter = false;
            }
        );

        $scope.$on(
            platformSettingsService.BROADCAST.NEW_QUICK_FILTER,
            function (e, res) {
                if (res.error) {
                    vm.uiNewQuickFilterSuccessRes = false;
                    vm.uiNewQuickFilterErrorRes = true;
                    return;
                }

                vm.quickFilters.push({
                    name: res.name,
                    networkPointList: res.selectedNetworkPoints
                });
                if (vm.quickFilters.length >= 5) {
                    vm.uiMaximumNumberOfFiltersReached = true;
                }
                vm.uiShowAddNewQuickFilter = false;
                vm.uiNewQuickFilterSuccessRes = true;
            }
        );

        $scope.$on(
            platformSettingsService.BROADCAST.EDIT_QUICK_FILTER,
            function (e, res) {
                if (res.error) {
                    vm.uiEditQuickFilterSuccessRes = false;
                    vm.uiEditQuickFilterErrorRes = true;
                } else {
                    var i;
                    for (i = 0; i < vm.quickFilters.length; i++) {
                        if (vm.quickFilters[i].name === res.oldName) {
                            vm.quickFilters[i] = {
                                name: res.name,
                                networkPointList: res.selectedNetworkPoints
                            };
                        }
                    }

                    vm.uiEditQuickFilterSuccessRes = true;
                }

                $timeout(function () {
                    vm.uiEditQuickFilterSuccessRes = false;
                    vm.uiEditQuickFilterErrorRes = false;
                }, NotificationConstants.duration);
            }
        );

        $scope.$on(
            platformSettingsService.BROADCAST.CANCEL_EDIT_QUICK_FILTER,
            function () {}
        );

        function remove() {
            NetworkPoint.deleteQuickFilter(
                { name: vm.quickFilterToBeRemoved.name },
                function () {
                    vm.uiDeleteQuickFilterSuccessRes = true;
                    vm.uiDeleteQuickFilterErrorRes = false;
                    vm.quickFilters.splice(
                        vm.quickFilters.indexOf(vm.quickFilterToBeRemoved),
                        1
                    );
                    if (vm.quickFilters.length < 5) {
                        vm.uiMaximumNumberOfFiltersReached = false;
                    }
                    $timeout(function () {
                        vm.uiDeleteQuickFilterSuccessRes = false;
                    }, NotificationConstants.duration);
                },
                function () {
                    vm.uiDeleteQuickFilterErrorRes = true;
                    $timeout(function () {
                        vm.uiDeleteQuickFilterErrorRes = false;
                    }, NotificationConstants.duration);
                }
            );
        }
    }
})();
